module.exports = __webpack_public_path__ + "a7f04cab55c970d9e356b888cf0dfc42.png";